$.cookie = function (key, value, options) {
   if (
      arguments.length > 1 &&
      (!/Object/.test(Object.prototype.toString.call(value)) ||
         value === null ||
         value === undefined)
   ) {
      options = $.extend({}, options);
      if (value === null || value === undefined) {
         options.expires = -1;
      }
      if (typeof options.expires === "number") {
         var days = options.expires,
            t = (options.expires = new Date());
         t.setDate(t.getDate() + days);
      }
      value = String(value);
      return (document.cookie = [
         encodeURIComponent(key),
         "=",
         options.raw ? value : encodeURIComponent(value),
         options.expires ? "; expires=" + options.expires.toUTCString() : "",
         options.path ? "; path=" + options.path : "",
         options.domain ? "; domain=" + options.domain : "",
         options.secure ? "; secure" : "",
      ].join(""));
   }
   options = value || {};
   var decode = options.raw
      ? function (s) {
           return s;
        }
      : decodeURIComponent;
   var pairs = document.cookie.split("; ");
   for (var i = 0, pair; (pair = pairs[i] && pairs[i].split("=")); i++) {
      if (decode(pair[0]) === key) return decode(pair[1] || "");
   }
   return null;
};

if (typeof Shopify === "undefined") {
   Shopify = {};
}
if (!Shopify.formatMoney) {
   Shopify.formatMoney = function (cents, format) {
      var value = "",
         placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
         formatString = format || this.money_format;
      if (typeof cents == "string") {
         cents = cents.replace(".", "");
      }

      function defaultOption(opt, def) {
         return typeof opt == "undefined" ? def : opt;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
         precision = defaultOption(precision, 2);
         thousands = defaultOption(thousands, ",");
         decimal = defaultOption(decimal, ".");
         if (isNaN(number) || number == null) {
            return 0;
         }
         number = (number / 100.0).toFixed(precision);
         var parts = number.split("."),
            dollars = parts[0].replace(
               /(\d)(?=(\d\d\d)+(?!\d))/g,
               "$1" + thousands
            ),
            cents = parts[1] ? decimal + parts[1] : "";
         return dollars + cents;
      }
      switch (formatString.match(placeholderRegex)[1]) {
         case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
         case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
         case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
         case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
      }
      return formatString.replace(placeholderRegex, value);
   };
}

window.novtheme = window.novtheme || {};
var isLoggedIn;
isLoggedIn = false;
var current_width = $(window).width(),
   min_width = 768,
   responsive_mobile = current_width < min_width,
   flag_sticky = false;

var wishListsArr = localStorage.getItem("wishListsArr")
   ? JSON.parse(localStorage.getItem("wishListsArr"))
   : [];
localStorage.setItem("wishListsArr", JSON.stringify(wishListsArr));
if (wishListsArr.length) {
   wishListsArr = JSON.parse(localStorage.getItem("wishListsArr"));
}

// Custom sort function for sorting products by vendor
novtheme.sortProductsByVendor = function(sortOrder) {
   var $productGrid = $('#product-grid');
   var $products = $productGrid.children('.product--item');
   
   // Convert to array and sort
   var productsArray = $products.get();
   productsArray.sort(function(a, b) {
      // Get vendor from the .item-product div inside .product--item
      var vendorA = $(a).find('.item-product').attr('data-vendor') || '';
      var vendorB = $(b).find('.item-product').attr('data-vendor') || '';
      
      // Normalize for comparison (case-insensitive, trim spaces)
      vendorA = vendorA.toLowerCase().trim();
      vendorB = vendorB.toLowerCase().trim();
      
      if (sortOrder === 'vendor-ascending') {
         // A to Z
         if (vendorA < vendorB) return -1;
         if (vendorA > vendorB) return 1;
         return 0;
      } else if (sortOrder === 'vendor-descending') {
         // Z to A
         if (vendorA > vendorB) return -1;
         if (vendorA < vendorB) return 1;
         return 0;
      }
      return 0;
   });
   
   // Remove all products from grid
   $products.detach();
   
   // Append sorted products back to grid
   $.each(productsArray, function(index, item) {
      $productGrid.append(item);
   });
};

novtheme.init = function () {
   var steps = [
      "cacheSelectors",
      "eventBlockCart",
      "hoverAccount",
      "popupCart",
      "NoneThumbnailProductDetail",
      "VerticalThumbnailProductDetail",
      "ThumbnailProductDetail",
      "RelatedBlog",
      "load_canvas_menu",
      "NovTogglePage",
      "galery_image",
      "click_button_canvas_menu",
      "productImageSwitch",
      "goToTopMobile",
      "NovHeightBoxContent",
      "MenuSidebar",
      "NovToggleAction",
      "NovToggleSearch",
      "NovEventClickSearchMobile",
      "Product__Thumnail",
      "Product_Megamenu",
      "NovMediumToggle",
      "HideShowPassword",
      "tooltip",
      "CollectionPage",
      "NovAccordion",
      "variantName",
      "RunInstagram"
   ];
   for (var i = 0; i < steps.length; i++) {
      try {
         if (typeof novtheme[steps[i]] === "function") {
            novtheme[steps[i]]();
         }
      } catch (err) {}
   }
   
   /* ========== TEST #3 - STICKY HEADER DÉSACTIVÉ ==========
    * Le StickyHeader écoute tous les événements scroll sur desktop.
    * Désactivé pour tester si ça cause le freeze avec Transtore.
    * Date: 2025-11-12
    */
   /*
   if (current_width >= 992) {
      novtheme.StickyHeader(true);
      flag_sticky = true;
   }
   */
   /* ========== FIN TEST #3 ========== */
};

//Tooltip, activated by hover event
novtheme.tooltip = function () {
   $("body").tooltip({
      selector: "[data-toggle='tooltip']",
      container: "body",
   });
};
novtheme.swapChildren = function (obj1, obj2) {
   var temp = obj2.children().detach();
   obj2.empty().append(obj1.children().detach());
   obj1.append(temp);
};

var mobileLayoutApplied = false;
var mobileLayoutSkipIds = {
   _desktop_cart_count: true,
   _desktop_back_top: true,
   _mobile_cart_count: true,
};

window.isMobileViewport = function () {
   return window.matchMedia("(max-width: 767px)").matches;
};

window.updateCartBadges = function (itemCount) {
   var count = parseInt(itemCount, 10);
   if (isNaN(count)) count = 0;
   var text = String(count);

   $("#CartCount").text(text);
   $("#MobileCartCount").text(text);

   if (count === 0) {
      $(".site-header__cart-count, #_mobile_cart_count").addClass("hidden-count is-empty");
   } else {
      $(".site-header__cart-count, #_mobile_cart_count").removeClass("hidden-count is-empty");
   }
};

novtheme.applyMobileLayout = function () {
   if (!window.isMobileViewport() || mobileLayoutApplied) return;

   $("[id^='_desktop_']").each(function (idx, el) {
      if (mobileLayoutSkipIds[el.id]) return;
      var $target = $("#" + el.id.replace("_desktop_", "_mobile_"));
      if (!$target.length) return;
      $target.append($(el).children().detach());
   });

   mobileLayoutApplied = true;
};

novtheme.restoreDesktopLayout = function () {
   if (window.isMobileViewport() || !mobileLayoutApplied) return;

   $("[id^='_mobile_']").each(function (idx, el) {
      if (mobileLayoutSkipIds[el.id]) return;
      var $target = $("#" + el.id.replace("_mobile_", "_desktop_"));
      if (!$target.length) return;
      $target.append($(el).children().detach());
   });

   mobileLayoutApplied = false;
};

novtheme.toggleMobileStyles = function () {
   if (window.isMobileViewport()) {
      novtheme.applyMobileLayout();
   } else {
      novtheme.restoreDesktopLayout();
   }
};
novtheme.toggleSticky = function (action) {
   if (action == true) {
      $("*[class^='contentsticky_']").each(function (idx, el) {
         var target = $(
            "." +
               el.classList["0"].replace("contentsticky_", "contentstickynew_")
         );
         if (target.length) {
            novtheme.swapChildren($(el), target);
         }
      });
   } else {
      $("*[class^='contentstickynew_']").each(function (idx, el) {
         var target = $(
            "." +
               el.classList["0"].replace("contentstickynew_", "contentsticky_")
         );
         if (target.length) {
            novtheme.swapChildren($(el), target);
         }
      });
   }
};

novtheme.StickyHeader = function (flag_sticky) {
   if ($(".site-header").hasClass("sticky-menu")) {
      if (flag_sticky == true) {
         var time;
         var height = $(".site-header").height();
         var flag = true;
         $(window).scroll(function () {
            if (time) clearTimeout(time);
            time = setTimeout(function () {
               if ($(window).scrollTop() > height) {
                  if (flag == true) {
                     $("#header-sticky").addClass("sticky-menu-active");
                     $(".site-header").css("height", height);
                     novtheme.toggleSticky(true);
                     flag = false;
                  }
               } else {
                  if (flag == false) {
                     $("#header-sticky").removeClass("sticky-menu-active");
                     novtheme.toggleSticky(false);
                     $(".site-header").css("height", "auto");
                     flag = true;
                  }
               }
            }, 100);
         });
      }
   }
};
var flag_sticky = false;
$(window).on("resize", function () {
   var _cw = current_width;
   var _mw = min_width;
   var _w = $(window).width();
   var _toggle = (_cw >= _mw && _w < _mw) || (_cw < _mw && _w >= _mw);
   responsive_mobile = _w < _mw;
   current_width = _w;
   if (_toggle) {
      novtheme.toggleMobileStyles();
      novtheme.load_canvas_menu();
      novtheme.NovTogglePage();
      novtheme.NovHeightBoxContent();
      novtheme.popupCart();
   }
   if (current_width <= 768) {
      if (flag_sticky == true) {
         novtheme.toggleSticky(false);
         $("#header-sticky").removeClass("sticky-menu-active");
      }
   } else {
   }
});
novtheme.popupCart = function (e) {
   $(document).on("click", ".popupCartClose", function (e) {
      e.preventDefault();
      $("#popup-Cart .jsPopupview").html("");
      $("#popup-Cart").modal("toggle");
   });
};
novtheme.click_button_canvas_menu = function () {
   $("#show-megamenu").on("click", function () {
      if ($(".canvas-menu").hasClass("active")) {
         $(".canvas-menu").removeClass("active");
         $("body").removeClass("canvasmenu-right");
         $(this).removeClass("close");
      } else {
         $(".canvas-menu").addClass("active");
         $("body").addClass("canvasmenu-right");
         $(this).addClass("close");
      }
      return false;
   });
};
// Menu mobile v1 : Marques en lien direct, sous-menus a plat, genres en photos.
function fsPrepareMobileMenuV1($menu) {
   var imgs = window.fsMobileMenuGenreImages || {};
   $menu.find(".site-nav > li").each(function () {
      var $li = $(this);
      var $toggle = $li.children("a.site-nav__parent-toggle").first();
      var href = $toggle.attr("data-parent-href") || "";
      if (/\/pages\/marques(\?|$)/.test(href)) {
         var title = $.trim($toggle.find(".group_title").first().text());
         var $a = $('<a class="site-nav__link site-nav__link--main"></a>').attr("href", href);
         $a.append($('<div class="group_title"></div>').text(title));
         $a.attr("style", $toggle.attr("style") || "");
         $li
            .empty()
            .append($a)
            .removeClass("site-nav--has-dropdown menu_mb fs-mega-host")
            .removeAttr("aria-controls data-fs-mega-host")
            .addClass("fs-mm-direct");
         return;
      }
      $li.find(".site-nav__dropdown > ul > li.site-nav__childlist-item").each(function () {
         var $group = $(this);
         var $kids = $group.find(".site-nav__dropdown-children > ul > li");
         if (!$kids.length) return;
         var label = $.trim($group.find(".group_title").first().text());
         var $head = $('<li class="fs-mm-heading"></li>').append($("<span></span>").text(label));
         $group.before($head);
         $head.after($kids.detach());
         $group.remove();
      });
   });
   var genres = [
      ["/collections/parfums-masculins", imgs.m],
      ["/collections/oriente-feminin", imgs.f],
      ["/collections/parfums-unisexes", imgs.u],
   ];
   var $genreLis = $();
   $.each(genres, function (_, g) {
      var $a = $menu.find('.site-nav__dropdown > ul > li > a[href*="' + g[0] + '"]').first();
      if (!$a.length || !g[1]) return;
      $a.css(
         "background-image",
         "radial-gradient(130% 120% at 0% 100%, rgba(20,10,12,.78) 0%, rgba(20,10,12,.4) 45%, rgba(20,10,12,0) 75%), url(" + g[1] + ")"
      );
      $genreLis = $genreLis.add($a.parent().addClass("fs-mm-genre"));
   });
   if ($genreLis.length) {
      $genreLis.first().parent().prepend($genreLis);
   }
}
// Menu mobile : tuiles du mega desktop en cartes 2 colonnes (style home, fs-mm-tiles-v4).
function fsMobileMenuTiles($menu) {
   var subs = window.fsMobileMenuTileSubs || {};
   $menu.find(".site-nav > li").each(function () {
      var thumbs = {};
      $(this).find(".fs-mega__tiles a.fs-mega__tile").each(function () {
         var src = $(this).find("img").attr("src");
         if (src) thumbs[$(this).attr("href")] = src;
      });
      var $links = $(this).find(".site-nav__dropdown > ul > li > a").filter(function () {
         return !!thumbs[$(this).attr("href")];
      });
      if (!$links.length) return;
      $links.each(function () {
         var $a = $(this);
         var href = $a.attr("href");
         var handle = (href.split("?")[0].match(/\/collections\/([^\/]+)/) || [])[1] || "";
         var $copy = $('<span class="fs-mm-card__copy"></span>')
            .append($('<span class="fs-mm-card__name"></span>').text($.trim($a.text())));
         if (subs[handle]) $copy.append($('<span class="fs-mm-card__sub"></span>').text(subs[handle]));
         $a.empty()
            .addClass("fs-mm-card")
            .append($('<img class="fs-mm-card__img" alt="" loading="lazy">').attr("src", thumbs[href]))
            .append('<span class="fs-mm-card__shade"></span>')
            .append(
               $('<span class="fs-mm-card__txt"></span>')
                  .append($copy)
                  .append('<span class="fs-mm-card__arrow" aria-hidden="true">→</span>')
            );
         $a.parent().addClass("fs-mm-tile");
      });
      var seasons = ["printemps", "ete", "automne", "hiver"];
      var rank = function (li) {
         var h = ($(li).children("a").attr("href") || "").split("?")[0].replace(/.*\/collections\//, "");
         var i = seasons.indexOf(h);
         return i < 0 ? 0 : i;
      };
      var $tiles = $($links.parent().get().sort(function (a, b) { return rank(a) - rank(b); }));
      var $wrap = $('<li class="fs-mm-tiles-wrap"></li>');
      $tiles.first().before($wrap);
      $wrap.append($('<ul class="fs-mm-tiles"></ul>').append($tiles.detach()));
   });
}
novtheme.load_canvas_menu = function () {
   var $main_menu = $(".site-nav", "#AccessibleNav");
   if (current_width < 768) {
      if ($("#canvas-main-menu").length < 1 && $main_menu.length > 0) {
         var $menu = $main_menu.parent().clone();
         $menu.attr("id", "canvas-main-menu");
         // Aligner les titres du clone mobile sur les libelles du menu desktop.
         $menu
            .find('a[href*="/pages/notes-olfactives"] .group_title')
            .text("Notes olfactives");
         $menu.find(".site-nav > li > a .group_title").each(function () {
            var $title = $(this);
            var currentTitle = $.trim($title.text()).toLocaleLowerCase("fr");
            if (currentTitle === "sélections" || currentTitle === "selections") {
               $title.text("Univers");
            } else if (currentTitle === "concept") {
               $title.text("Le concept");
            } else if (currentTitle === "discontinués" || currentTitle === "discontinues") {
               $title.text("Raretés");
            }
         });
         $menu.attr("data-fs-mobile-current-labels-v2", "true");
         fsPrepareMobileMenuV1($menu);
         fsMobileMenuTiles($menu);
         $($menu).find(".menu").removeAttr("id");
         // Mega menu desktop : pas dans le menu mobile (mmenu)
         $menu.find(".fs-mega").remove();
         $menu
            .find(
               "li.site-nav--has-dropdown > a, li.hasMegaMenu > a, li.icon_menu > a, a.site-nav__parent-toggle"
            )
            .each(function () {
               var $a = $(this);
               if (!$a.hasClass("mm-next")) {
                  $a.attr("href", "#").attr("role", "button");
               }
            });
         $(".canvas-menu").append($menu);
         $menu.mmenu({
            offCanvas: false,
            navbar: {
               title: false,
            },
         });
         // Toute la ligne ouvre le sous-menu + pas de texte dupliqué dans mm-next
         $menu.find("a.mm-next").each(function () {
            var $n = $(this);
            $n.addClass("mm-fullsubopen").attr("aria-label", "Ouvrir le sous-menu");
            $n.contents().filter(function () {
               return this.nodeType === 3;
            }).remove();
         });
         // Tous les sous-titres (A, A-B, C-E, parents…) → Libre Baskerville
         $menu.find(".mm-listview > li").each(function () {
            var $li = $(this);
            var hasNext = $li.children("a.mm-next").length > 0;
            var hasUl = $li.children("ul").length > 0;
            var $label = $li.children("a:not(.mm-next)").first();
            var t = ($label.text() || "").replace(/\s+/g, " ").trim();
            var looksLikeRange =
               t.length > 0 &&
               t.length <= 8 &&
               (/^[A-Za-z0-9]$/.test(t) ||
                  /^[A-Za-z0-9]\s*[-–—]\s*[A-Za-z0-9]/.test(t) ||
                  /^[A-Za-z]{1,3}$/.test(t));
            if (
               hasNext ||
               hasUl ||
               $li.hasClass("much_menu") ||
               $li.hasClass("menu_mega") ||
               $li.hasClass("fs-nav-letter") ||
               looksLikeRange
            ) {
               $li.addClass("fs-nav-subtitle");
            }
         });

         // Titre + Retour dans le bandeau fixe (même niveau que la croix)
         var $titleEl = $("#fs-canvas-nav-title");
         var $backEl = $("#fs-canvas-nav-back");
         var api = $menu.data("mmenu");
         function fsSyncCanvasNavHeader() {
            var $panel = $menu.find(".mm-panel.mm-current, .mm-panel.mm-opened").last();
            if (!$panel.length) $panel = $menu.find(".mm-panel").first();
            var titleText = $.trim(
               $panel.find("> .mm-navbar .mm-title").first().text() || ""
            );
            if ($panel.hasClass("mm-hasnavbar") && titleText) {
               $titleEl.text(titleText).prop("hidden", false);
               $backEl.prop("hidden", false);
               $(".canvas-menu").addClass("fs-canvas-nav--sub");
            } else {
               $titleEl.text("").prop("hidden", true);
               $backEl.prop("hidden", true);
               $(".canvas-menu").removeClass("fs-canvas-nav--sub");
            }
         }
         $backEl.off("click.fsNav").on("click.fsNav", function (e) {
            e.preventDefault();
            var $prev = $menu
               .find(".mm-panel.mm-current, .mm-panel.mm-opened")
               .last()
               .find("> .mm-navbar .mm-btn.mm-prev")
               .first();
            if ($prev.length) {
               $prev.trigger("click");
            } else if (api && typeof api.closeAllPanels === "function") {
               api.closeAllPanels();
            }
            setTimeout(fsSyncCanvasNavHeader, 30);
         });
         if (api && typeof api.bind === "function") {
            api.bind("openPanel:finish", fsSyncCanvasNavHeader);
            api.bind("closePanel:finish", fsSyncCanvasNavHeader);
         }
         $menu.on("click", "a.mm-next, a.mm-prev, .mm-btn", function () {
            setTimeout(fsSyncCanvasNavHeader, 40);
         });
         $(document)
            .off("click.fsNavSync")
            .on("click.fsNavSync", "#show-megamenu", function () {
               setTimeout(fsSyncCanvasNavHeader, 50);
            });
         setTimeout(fsSyncCanvasNavHeader, 0);

         novtheme.remove_canvas_menu();
      }
   }
};
novtheme.remove_canvas_menu = function () {
   $(".canvas-header-box .close-box, .canvas-overlay").on("click", function () {
      $(".canvas-menu").removeClass("active");
      $("body").removeClass("canvasmenu-right");
      return false;
   });
};
novtheme.NoneThumbnailProductDetail = function () {
   if ($("html").hasClass("lang-rtl")) rtl = true;
   else rtl = false;
   var autoplay = $("#productThumbs .owl-carousel").data("autoplay");
   var autoplaytimeout = $("#productThumbs .owl-carousel").data(
      "autoplaytimeout"
   );
   var items = $("#productThumbs .owl-carousel").data("items");
   var margin = $("#productThumbs .owl-carousel").data("margin");
   var nav = $("#productThumbs .owl-carousel").data("nav");
   var dots = $("#productThumbs .owl-carousel").data("dots");
   var loop = $("#productThumbs .owl-carousel").data("loop");
   var items_tablet = $("#productThumbs .owl-carousel").data("items_tablet")
      ? $("#productThumbs .owl-carousel").data("items_tablet")
      : 3;
   var items_mobile = $("#productThumbs .owl-carousel").data("items_mobile")
      ? $("#productThumbs .owl-carousel").data("items_mobile")
      : 1;
   var center = $("#productThumbs .owl-carousel").data("center")
      ? $("#productThumbs .owl-carousel").data("center")
      : false;
   var start = $("#productThumbs .owl-carousel").data("start")
      ? $("#productThumbs .owl-carousel").data("start")
      : 0;
   $("#productThumbs .owl-carousel").owlCarousel({
      navText: [
         '<i class="zmdi zmdi-chevron-left"></i>',
         '<i class="zmdi zmdi-chevron-right"></i>',
      ],
      lazyLoad: true,
      lazyContent: true,
      loop: loop,
      autoplay: autoplay,
      autoplayTimeout: autoplaytimeout,
      items: items,
      margin: margin,
      rtl: rtl,
      dots: dots,
      nav: nav,
      center: center,
      responsive: {
         0: {
            items: 1,
            center: center,
            margin: 0,
         },
         576: {
            items: items_mobile,
            center: center,
            margin: 10,
         },
         768: {
            items: items_tablet,
            margin: 10,
         },
         992: {
            items: items,
            margin: margin,
         },
         1200: {
            items: items,
            startPosition: start,
            margin: margin,
         },
      },
   });
};
novtheme.VerticalThumbnailProductDetail = function () {
   if ($("html").hasClass("lang-rtl")) var rtl = true;
   else var rtl = false;
   if (typeof $.fn.slick !== "function") return;
   $(".thumb_vertical_slick").slick({
      nextArrow:
         '<div class="arrow-next"><i class="zmdi zmdi-chevron-down"></i></div>',
      prevArrow:
         '<div class="arrow-prev"><i class="zmdi zmdi-chevron-up"></i></div>',
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 5,
      vertical: true,
      verticalSwiping: true,
      arrows: false,
      responsive: [
         {
            breakpoint: 1200,
            settings: {
               slidesToShow: 4,
               slidesToScroll: 4,
               arrows: false,
            },
         },
         {
            breakpoint: 992,
            settings: {
               arrows: false,
               slidesToShow: 4,
               slidesToScroll: 4,
            },
         },
         {
            breakpoint: 768,
            settings: {
               vertical: false,
               verticalSwiping: false,
               arrows: false,
               slidesToShow: 4,
               slidesToScroll: 4,
            },
         },
         {
            breakpoint: 480,
            settings: {
               vertical: false,
               verticalSwiping: false,
               arrows: false,
               slidesToShow: 3,
               slidesToScroll: 3,
            },
         },
      ],
   });
   
   /* ========== TEST #1 - MOUSEWHEEL LISTENER DÉSACTIVÉ ==========
    * Ce code gère la galerie verticale (thumb_vertical) qui n'est pas utilisée.
    * Désactivé pour tester si ça cause le freeze avec Transtore.
    * Date: 2025-11-12
    */
   /*
   if ($(window).width() > 991 && $(".template-product").length > 0) {
      $(window).on("mousewheel DOMMouseScroll wheel", function (e) {
         $(".thumb_vertical .proFeaturedImage .item.act").each(function () {
            var item = $(this),
               p = item.data("position"),
               hd = item.height() / 2,
               hu = item.height() - 150,
               srt = $(window).scrollTop(),
               y = e.originalEvent.deltaY,
               offset_top = item.offset().top;
            if (y > 0) {
               if (p < $(".proFeaturedImage .item").length) {
                  var npd = p + 1;
               } else {
                  var npd = p;
               }
               if (srt > offset_top + hd) {
                  item.removeClass("act");
                  $(
                     '.proFeaturedImage .item[data-position="' + npd + '"]'
                  ).addClass("act");
                  $('.thumbItem[data-position="' + p + '"]').removeClass(
                     "active"
                  );
                  $('.thumbItem[data-position="' + npd + '"]').addClass(
                     "active"
                  );
               }
            } else {
               if (p > 1) {
                  var npu = p - 1;
               } else {
                  var npu = p;
               }
               if (srt < offset_top - hd) {
                  item.removeClass("act");
                  $(
                     '.proFeaturedImage .item[data-position="' + npu + '"]'
                  ).addClass("act");
                  $('.thumbItem[data-position="' + p + '"]').removeClass(
                     "active"
                  );
                  $('.thumbItem[data-position="' + npu + '"]').addClass(
                     "active"
                  );
               }
            }
         });
      });
      $(".product-thumb_vertical .thumbItem").click(function () {
         var p = $(this).data("position");
         $(".product-thumb_vertical .thumbItem").removeClass("active");
         $(this).addClass("active");
         $(".proFeaturedImage .item").removeClass("act");
         $('.proFeaturedImage .item[data-position="' + p + '"]').addClass(
            "act"
         );
         var ost = $(".proFeaturedImage .item.act").offset().top;
         $("body,html").animate({ scrollTop: ost - 30 }, "normal");
      });
   }
   */
   /* ========== FIN TEST #1 ========== */
   
   if ($(window).width() < 992) {
      if ($(document).width() <= 991) {
         $(".thumb_vertical .proFeaturedImage")
            .slick({
               slide: ".item",
               infinite: false,
               slidesToShow: 1,
               slidesToScroll: 1,
               adaptiveHeight: true,
            })
            .on("afterChange", function (e, o) {
               $("iframe").each(function () {
                  $(this)[0].contentWindow.postMessage(
                     '{"event":"command","func":"' +
                        "stopVideo" +
                        '","args":""}',
                     "*"
                  );
               });
               $("video").trigger("pause");
            });
         $(".thumb_vertical .proFeaturedImage").on(
            "afterChange",
            function (event, slick, currentSlide) {
               $("#productThumbs .thumb_vertical_slick").slick(
                  "slickGoTo",
                  currentSlide
               );
               $("#productThumbs .thumb_vertical_slick")
                  .find(".slick-slide.item-active")
                  .removeClass("item-active");
               $("#productThumbs .thumb_vertical_slick")
                  .find('.slick-slide[data-slick-index="' + currentSlide + '"]')
                  .addClass("item-active");
            }
         );

         $(".thumb_vertical .thumb_vertical_slick").on(
            "click",
            ".slick-slide",
            function (event) {
               event.preventDefault();
               var goToSingleSlide = $(this).data("slick-index");
               $(".thumb_vertical .proFeaturedImage").slick(
                  "slickGoTo",
                  goToSingleSlide
               );
            }
         );
      }
   }
};
novtheme.ThumbnailProductDetail = function () {
   var $FeaturedImage = $(".FeaturedImage_slick");
   var $ThumbImage = $("#productThumbs .thumb_slick");
   if ($("html").hasClass("lang-rtl")) var rtl = true;
   else var rtl = false;
   if (!$FeaturedImage.length || typeof $.fn.slick !== "function") return;

   /*
     Mobile (DPR 2.5/3…) : la largeur CSS est souvent fractionnaire.
     Slick calcule alors slideWidth / translate en sous-pixels → 1px du voisin.
     Desktop tombe souvent sur des px entiers → pas de bug.
     On verrouille la galerie sur une largeur entière avant toute mesure Slick.
   */
   var lockFeaturedPixelWidth = function () {
      var node = $FeaturedImage[0];
      if (!node) return;
      node.style.width = "";
      void node.offsetWidth;
      var w = Math.round(node.getBoundingClientRect().width);
      if (w > 0) node.style.width = w + "px";
   };

   lockFeaturedPixelWidth();
   $FeaturedImage.slick({
      slide: ".item",
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      adaptiveHeight: true,
      infinite: false,
      useTransform: true,
      speed: 400,
      cssEase: "cubic-bezier(0.77, 0, 0.18, 1)",
      rtl: rtl,
   });

   var refreshFeaturedLayout = function () {
      if (!$FeaturedImage.hasClass("slick-initialized")) return;
      lockFeaturedPixelWidth();
      $FeaturedImage.slick("setPosition");
   };
   $FeaturedImage.find("img").each(function () {
      if (this.complete) return;
      $(this).one("load", refreshFeaturedLayout);
   });
   $(window).on("load orientationchange", refreshFeaturedLayout);
   var resizeTimer;
   $(window).on("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refreshFeaturedLayout, 100);
   });

   var autoplay = $ThumbImage.data("autoplay"),
      autoplaytimeout = $ThumbImage.data("autoplaytimeout"),
      infinite = $ThumbImage.data("loop"),
      dots = $ThumbImage.data("dots"),
      nav = $ThumbImage.data("nav"),
      loop = $ThumbImage.data("loop"),
      fade = $ThumbImage.data("fade"),
      vertical = $ThumbImage.data("vertical"),
      verticalSwiping = $ThumbImage.data("vertical"),
      items = $ThumbImage.data("items"),
      items_lg = $ThumbImage.data("items_lg"),
      items_md = $ThumbImage.data("items_md"),
      items_sm = $ThumbImage.data("items_sm"),
      items_xs = $ThumbImage.data("items_xs");
   $ThumbImage
      .on("init", function (event, slick) {
         $(this).find(".slick-slide.slick-current").addClass("active");
      })
      .slick({
         slide: ".item",
         infinite: infinite,
         slidesToShow: items,
         slidesToScroll: 2,
         dots: dots,
         arrows: nav,
         rtl: rtl,
         vertical: vertical,
         verticalSwiping: verticalSwiping,
         focusOnSelect: false,
         responsive: [
            {
               breakpoint: 1920,
               settings: {
                  slidesToShow: items,
                  slidesToScroll: items,
               },
            },
            {
               breakpoint: 1200,
               settings: {
                  slidesToShow: items_lg,
                  slidesToScroll: items_lg,
               },
            },
            {
               breakpoint: 992,
               settings: {
                  slidesToShow: items_md,
                  slidesToScroll: items_md,
               },
            },
            {
               breakpoint: 768,
               settings: {
                  slidesToShow: items_sm,
                  slidesToScroll: items_sm,
                  verticalSwiping: false,
               },
            },
            {
               breakpoint: 576,
               settings: {
                  slidesToShow: items_xs,
                  slidesToScroll: items_xs,
                  vertical: false,
                  verticalSwiping: false,
               },
            },
         ],
      });

   $FeaturedImage.on("afterChange", function (event, slick, currentSlide) {
      $ThumbImage.slick("slickGoTo", currentSlide);
      $ThumbImage.find(".slick-slide.active").removeClass("active");
      $ThumbImage
         .find('.slick-slide[data-slick-index="' + currentSlide + '"]')
         .addClass("active");
      $("iframe").each(function () {
         $(this)[0].contentWindow.postMessage(
            '{"event":"command","func":"' + "stopVideo" + '","args":""}',
            "*"
         );
      });
      $("video").trigger("pause");
      // Type thumb all
      $(".thumb_all .thumbItem").removeClass("active");
      $('.thumb_all .thumbItem[data-position="' + currentSlide + '"]').addClass(
         "active"
      );
   });

   $ThumbImage.on("click", ".slick-slide", function (event) {
      event.preventDefault();
      var goToSingleSlide = $(this).data("slick-index");
      $FeaturedImage.slick("slickGoTo", goToSingleSlide);
   });
   // Type thumb all
   $(".thumb_all .thumbItem").on("click", function (event) {
      event.preventDefault();
      var position = $(this).data("position");
      $FeaturedImage.slick("slickGoTo", position);
   });
   $("[data-swatch-img]").on("click", function (event) {
      var dataimage = $(this).attr("data-img_src");
      var goToImage = $FeaturedImage
         .find('[data-image_src="' + dataimage + '"]')
         .data("slick-index");
      $FeaturedImage.slick("slickGoTo", goToImage);
   });
};
novtheme.RelatedBlog = function () {
   if ($("html").hasClass("lang-rtl")) rtl = true;
   else rtl = false;
   var $this = $(".BlogRelated .owl-carousel");
   var autoplay = $($this).data("autoplay");
   var autoplaytimeout = $($this).data("autoplaytimeout");
   var items = $($this).data("items");
   var margin = $($this).data("margin");
   var nav = $($this).data("nav");
   var dots = $($this).data("dots");
   var loop = $($this).data("loop");
   var items_tablet = $($this).data("items_tablet")
      ? $($this).data("items_tablet")
      : 3;
   var items_mobile = $($this).data("items_mobile")
      ? $($this).data("items_mobile")
      : 1;
   var center = $($this).data("center") ? $($this).data("center") : false;
   var start = $($this).data("start") ? $($this).data("start") : 0;
   $($this).owlCarousel({
      navText: [
         '<i class="fa fa-long-arrow-left"></i>',
         '<i class="fa fa-long-arrow-right"></i>',
      ],
      lazyLoad: true,
      lazyContent: true,
      loop: loop,
      autoplay: autoplay,
      autoplayTimeout: autoplaytimeout,
      items: items,
      margin: margin,
      rtl: rtl,
      dots: dots,
      nav: nav,
      responsive: {
         0: {
            items: items_mobile,
            center: center,
            margin: 15,
         },
         768: {
            items: items_tablet,
            margin: 15,
         },
         992: {
            items: items,
            margin: margin,
         },
         1200: {
            items: items,
            startPosition: start,
            margin: margin,
         },
      },
   });
};
novtheme.callbackReview = function () {
   if ($(".shopify-product-reviews-badge").length > 0) {
      return (
         window.SPR.registerCallbacks(),
         window.SPR.initRatingHandler(),
         window.SPR.initDomEls(),
         window.SPR.loadProducts(),
         window.SPR.loadBadges()
      );
   }
};
novtheme.productPage = function (options) {
   var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;
   var $productImage = $("#ProductPhotoImg"),
      $addToCart = $("#AddToCart"),
      $productPrice = $(".price-product-template"),
      $quantityElements = $(".quantity-selector, label + .js-qty"),
      $quantity = $(".product-form__item--quantity"),
      $addToCartText = $("#AddToCartText");
   if (variant) {
      try {
         var formattedPrice =
            theme.Currency && typeof theme.Currency.formatMoney === "function"
               ? theme.Currency.formatMoney(variant.price, moneyFormat)
               : (variant.price / 100).toFixed(2);
         $productPrice.html(formattedPrice + ".-");
      } catch (err) {}

      var form = selector && selector.domIdPrefix ? $("#" + selector.domIdPrefix).parents("form") : $(".product-form").first();
      var sectionId = form.find('select[name="id"]').data("section") || form.find('#productSelect').data("section") || "";
      var $comparePrice = sectionId ? $("#ComparePrice-" + sectionId) : $(".compareprice-product-template");

      for (var i = 0, length = variant.options.length; i < length; i++) {
         var radioButton = form.find(
            '.swatch[data-option-index="' +
               i +
               '"] :radio[value="' +
               variant.options[i] +
               '"]'
         );
         if (radioButton.length) {
            radioButton.get(0).checked = true;
         }
      }
      if (variant.featured_image) {
         var newImage = variant.featured_image;
         var element = $productImage[0];
         if (
            element &&
            typeof Shopify !== "undefined" &&
            Shopify.Image &&
            typeof Shopify.Image.switchImage === "function"
         ) {
            Shopify.Image.switchImage(
               newImage,
               element,
               function (src, imgObject, el) {
                  $(".thumblist img").each(function () {
                     var idProductImage = $(this).parent().data("image");
                     if (idProductImage == src) {
                        $(this).parent().trigger("click");
                        var position = $(this).parents(".owl-item").index();
                        $(".thumblist .owl-carousel").trigger(
                           "to.owl.carousel",
                           position
                        );
                        return false;
                     }
                  });
               }
            );
         }
      }
      if (variant.available) {
         var d_qty = $("#productSelect :selected").data("qty");
         if (d_qty < 1) {
            $addToCartText.html("" + theme.strings.preorder + "");
         } else {
            $addToCartText.html("" + theme.strings.addToCart + "");
         }
         $addToCart.removeClass("disabled").prop("disabled", false);
         $quantity.show();
         $addToCart.removeClass("disabled").prop("disabled", false);
         $quantityElements.show();
         $(".group-quantity .control-label").show();
         $(".group-quantity").css("margin-top", "0");
         $("input").parent(".swatch-element").find(".sold").hide();
      } else {
         $quantity.hide();
         $addToCart.addClass("disabled").prop("disabled", true);
         $addToCartText.html("" + theme.strings.notify_me + "");
         $quantityElements.hide();
         $("input:not(:checked)")
            .parent(".swatch-element")
            .find(".sold")
            .hide();
         $("input:checked").parent(".swatch-element").find(".sold").show();
         $("input:checked")
            .parent(".swatch-element")
            .attr("data-toggle", "modal");
         $(".group-quantity .control-label").hide();
         $(".group-quantity").css("margin-top", "30px");
      }
      $productPrice.html(
         theme.Currency.formatMoney(variant.price, moneyFormat) + '.-'
      );
      if (variant.compare_at_price > variant.price) {
         if ($comparePrice.length) {
            $comparePrice
               .html(
                  theme.Currency.formatMoney(variant.compare_at_price, moneyFormat) + '.-'
               )
               .css("display", "inline")
               .show();
         }
      } else {
         if ($comparePrice.length) {
            $comparePrice.hide();
         }
      }
      if (
         $("#currencies").length != 0 &&
         typeof Currency !== "undefined" &&
         typeof Currency.convertAll === "function" &&
         typeof Currency.convert === "function"
      ) {
         Currency.convertAll(
            shopCurrency,
            $("#currencies span.selected").attr("data-currency")
         );
      }
   } else {
      $quantity.removeClass("d-block");
      $addToCart.addClass("disabled").prop("disabled", true);
      $addToCartText.html("" + theme.strings.unavailable + "");
      $quantityElements.hide();
   }
};
novtheme.productImageSwitch = function () {
   if (novtheme.cache.$thumbImages.length) {
      $(".thumbItem").each(function () {
         var srcproFeatured = $("#ProductPhotoImg").attr("src");
         var srcthumnail = $(".product-single__thumbnail", this).attr(
            "data-image"
         );
      });
      novtheme.cache.$thumbImages.on("click", function (evt) {
         evt.preventDefault();
         var newImage = $(this).attr("data-image");
         $(".thumbItem").removeClass("active");
         $(this).parent().addClass("active");
         novtheme.switchImage(newImage, null, novtheme.cache.$productImage);
      });
   }
};
novtheme.switchImage = function (src, imgObject, el) {
   var $el = $(el);
   $el.attr("src", src);
};
novtheme.cacheSelectors = function () {
   novtheme.cache = {
      $html: $("html"),
      $body: $(document.body),
      $navigation: $("#AccessibleNav"),
      $mobileSubNavToggle: $(".mobile-nav__toggle"),
      $changeView: $(".change-view"),
      $productImage: $("#ProductPhotoImg"),
      $thumbImages: $("#productThumb").find("a.product-single__thumbnail"),
      $thumbImages: $("#productThumbs").find("a.product-single__thumbnail"),
      $thumbItem: $(".thumb_grid").find(".thumbItem"),

      $recoverPasswordLink: $("#RecoverPassword"),
      $hideRecoverPasswordLink: $("#HideRecoverPasswordLink"),
      $recoverPasswordForm: $("#RecoverPasswordForm"),

      $recoverPasswordIndex: $("#RecoverPasswordIndex"),
      $hideRecoverPasswordIndex: $("#HideRecoverPasswordIndex"),
      $recoverPasswordFormIndex: $("#RecoverPasswordFormIndex"),

      $customerLoginForm: $("#CustomerLoginForm"),
      $passwordResetSuccess: $("#ResetSuccess"),
   };
};
novtheme.eventBlockCart = function (e) {
   // WhatsApp : ne pas manipuler les styles inline du widget (casse le label OFF de la config app).
   // Le masquage à l'ouverture des panels est géré uniquement en CSS (body.canvasmenu-right, show-boxpage, etc.).
   
   // Cart canvas
   $(".cart_canvas .open_header_cart_canvas").click(function () {
      $(".header-cart-canvas").addClass("active");
   });
   $(".close_canvas_cart").click(function () {
      $(".header-cart-canvas").removeClass("active");
   });

   // Hover Cart
   if (!("ontouchstart" in document)) {
      $(".cart_dropdown .header-cart").hover(function () {
         if (!$(".cart_dropdown #cart-info").is(":visible")) {
            $(".cart_dropdown #cart-info").slideDown("fast");
         }
      });
      $(".cart_dropdown #cart_block").mouseleave(function () {
         $(".cart_dropdown #cart-info").slideUp("fast");
      });
   } else {
      //mobile
      $(".cart_dropdown .header-cart").click(function () {
         if ($("#cart-info").is(":visible")) {
            $("#cart-info").slideUp("fast");
         } else {
            $("#cart-info").slideDown("fast");
         }
      });
   }
};
novtheme.hoverAccount = function (e) {
   if ($(window).width() > 1199) {
      $(".site-header_myaccount").hover(
         function () {
            $(".site-header_myaccount").addClass("show");
            $(".account-list").addClass("show");
         },
         // Event two mouse out remove class
         function () {
            $(".site-header_myaccount").removeClass("show");
            $(".account-list").removeClass("show");
         }
      );
   }
};
novtheme.NovToggleAction = function () {
   $(document).on("click", function (f) {
      if ($(f.target).is(".nov_sideward") == false) {
         $(".nov-toggle").removeClass("active");
         $(".nov-toggle .nov-toggle-btn").removeClass("act");
         $(".canvas-overlay").removeClass("act");
      }
      if ($(f.target).is(".nov-toggle .nov-toggle-btn") == true) {
         $(".nov-toggle").removeClass("active");
         $(".nov-toggle .nov-toggle-btn").removeClass("act");
         $(".canvas-overlay").removeClass("act");
      }
   });
};
novtheme.NovToggleSearch = function () {
   $(".search-toggle").on("click.break", function (event) {
      var wrapper = $(".overlay-search");
      wrapper.addClass("open");
      $(".site-header").addClass("open");
      $("#header-sticky").addClass("open");
      $("body").addClass("open");
      // Focus automatique sur le champ de recherche avec un léger délai pour l'animation
      setTimeout(function() {
         $(".overlay-search .search-header__input").focus();
      }, 300);
   });
   $(".close-search", ".overlay-search").on("click.break", function (event) {
      var wrapper = $(".overlay-search");
      wrapper.removeClass("open");
      $(".site-header").removeClass("open");
      $("#header-sticky").removeClass("open");
      $("body").removeClass("open");
   });
};

// Fonction globale pour mettre à jour le titre du panier mobile
function updateMobileCartTitle() {
   $.getJSON('/cart.js', function(cart) {
      var $titleCount = $('#_mobile_cart_title_count');
      if ($titleCount.length) {
         if (cart.item_count === 0) {
            $titleCount.text($titleCount.data('empty') || '(vide)');
         } else {
            var itemText = cart.item_count > 1 ? ($titleCount.data('many') || 'articles') : ($titleCount.data('one') || 'article');
            $titleCount.text('(' + cart.item_count + ' ' + itemText + ')');
         }
      }
   });
}

novtheme.NovTogglePage = function () {
   $(".nov-toggle-page").on("click", function (e) {
      var target = $(this).data("target");
      
      // Si on ouvre le panier mobile, charger le contenu à jour
      if (target === "#mobile-blockcart" && !$(target).hasClass("active")) {
         $.get("/cart?view=json", function (data) {
            $("#_mobile_cart").html(data);

            if (typeof updateMobileCartTitle === "function") {
               updateMobileCartTitle();
            }

            if (typeof moveMobileProgressBar === "function") {
               setTimeout(moveMobileProgressBar, 100);
            }
         });
      }
      
      $("body").hasClass("show-boxpage")
         ? $("body").removeClass("show-boxpage")
         : $("body").addClass("show-boxpage");
      $(target).hasClass("active")
         ? $(target).removeClass("active")
         : $(target).addClass("active");
      e.preventDefault();
   });
   $(".box-header .close-box").on("click", function (e) {
      $("body").removeClass("show-boxpage");
      $(this).parents(".mobile-boxpage").removeClass("active");
      $(".back-box", "#mobile-pageaccount").removeClass("active");
      $("#mobile-pageaccount").find(".box-content").removeClass("active");
      e.preventDefault();
   });
   $(".links-currency, .links-language").on("click", function (e) {
      var target_link = $(this).data("target"),
         title_box = $(this).data("titlebox");
      $("#mobile-pageaccount").find(".box-content").removeClass("active");
      $(".title-box", "#mobile-pageaccount").html(title_box);
      $(".back-box", "#mobile-pageaccount").addClass("active");
      $(target_link).hasClass("active")
         ? $(target_link).removeClass("active")
         : $(target_link).addClass("active");
      e.preventDefault();
   });
   $(".back-box", "#mobile-pageaccount").on("click", function (e) {
      var titlebox_parent = $("#mobile-pageaccount").data("titlebox-parent");
      $("#mobile-pageaccount").find(".box-content").removeClass("active");
      $(".title-box", "#mobile-pageaccount").html(titlebox_parent);
      $(this).removeClass("active");
      e.preventDefault();
   });
};
novtheme.NovHeightBoxContent = function () {
   var height = $(window).outerHeight(),
      boxheight = $(".box-header").outerHeight(),
      menubottom = $("#stickymenu_bottom_mobile").outerHeight();
   $(".box-content", ".mobile-boxpage").each(function () {
      $(this).outerHeight(height - 45);
   });
};
novtheme.NovEventClickSearchMobile = function () {
   $("#stickymenu_bottom_mobile .js-btn-search").click(function () {
      $("#mobile_search .search-header__input").focus();
      $("body,html").animate(
         {
            scrollTop: 0,
         },
         "normal"
      );
   });
};
novtheme.goToTop = function () {
   var timer;
   $(window).scroll(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
         if ($(window).scrollTop() >= 200) {
            $("#_desktop_back_top").fadeIn();
         } else {
            $("_desktop_back_top").fadeOut();
         }
      }, 300);
   });
   $("#_desktop_back_top").click(function () {
      $("body,html").animate({ scrollTop: 0 }, "normal");
      return !1;
   });
};
novtheme.goToTopMobile = function () {
   if ($(window).width() < 768) {
      var timer;
      $(window).scroll(function () {
         if (timer) clearTimeout(timer);
         timer = setTimeout(function () {
            $("#back_top").fadeIn();
         }, 200);
      });
      $("#back_top").click(function () {
         $("body,html").animate(
            {
               scrollTop: 0,
            },
            "normal"
         );
         return !1;
      });
   }
};
novtheme.PopupNewletter = function () {
   var date = new Date();
   var minutes = 60;
   date.setTime(date.getTime() + minutes * 60 * 1000);
   if (
      $.cookie("popupNewLetterStatus") != "closed" &&
      $("body").outerWidth() > 768
   ) {
      $("#popup-subscribe").modal({
         show: !0,
      });
   }
   $.cookie("popupNewLetterStatus", "closed", {
      expires: date,
      path: "/",
   });
   $("input.no-view").change(function () {
      if ($("input.no-view").prop("checked") == 1) {
         $.cookie("popupNewLetterStatus", "closed", {
            expires: date,
            path: "/",
         });
      } else {
         $.cookie("popupNewLetterStatus", "", {
            expires: date,
            path: "/",
         });
      }
   });
};
novtheme.variantName = function () {
   if ($(".template-product .thumb_grid").length > 0) {
      var val = $(
         '.swatch[data-option-index="0"] .swatch-element input:checked'
      )
         .parent()
         .data("value");
      $('.thumbItem[data-variant="' + val + '"]').addClass("show");

      $('.swatch[data-option-index="0"] .swatch-element label').on(
         "click",
         function () {
            var value = $(this).parent().data("value");
            $(".thumbItem").removeClass("show");
            $('.thumbItem[data-variant="' + value + '"]').addClass("show");
         }
      );
   }
};
novtheme.MenuSidebar = function () {
   if ($(window).width() < 768) {
      $(".filter-item_title").click(function () {
         $(".filter-item_content").slideUp();
         if ($(this).hasClass("add")) {
            $(this).next().slideUp();
            $(this).removeClass("add");
         } else {
            $(this).next().slideDown();
            $(".filter-item_title").removeClass("add");
            $(this).addClass("add");
         }
      });
   }
};
//Thumnail Slick Product Deal
novtheme.Product__Thumnail = function () {
   $(".product-thumb .item-product").each(function (index) {
      var asNavFor_nav = $(".thumnailslider-for", this).data("asnavfornav");
      var autoplay = $(".thumnailslider-nav", this).data("autoplay");
      var autoplayTimeout = $(".thumnailslider-nav", this).data(
         "autoplayTimeout"
      );
      var items = $(".thumnailslider-nav", this).data("items");
      var items_lg_tablet = $(".thumnailslider-nav", this).data(
         "items_lg_tablet"
      );
      var items_tablet = $(".thumnailslider-nav", this).data("items_tablet");
      var items_mobile = $(".thumnailslider-nav", this).data("items_mobile");
      var items_mobiles = $(".thumnailslider-nav", this).data("items_mobiles");
      var margin = $(".thumnailslider-nav", this).data("margin");
      var nav = $(".thumnailslider-nav", this).data("nav");
      var dots = $(".thumnailslider-nav", this).data("dots");
      var loop = $(".thumnailslider-nav", this).data("loop");
      var vertical = $(".thumnailslider-nav", this).data("vertical");
      var position = $(".thumnailslider-nav", this)
         .find(".selected")
         .data("position-image");
      var asNavFor_for = $(".thumnailslider-nav", this).data("asnavforfor");
      if ($("html").hasClass("lang-rtl")) var rtl = true;
      else var rtl = false;
      $(asNavFor_for, this).slick({
         rtl: rtl,
         slidesToShow: 1,
         slidesToScroll: 1,
         arrows: false,
         dots: false,
         fade: true,
         loop: false,
         arrows: false,
         asNavFor: asNavFor_nav,
      });
      $(asNavFor_nav, this).slick({
         rtl: rtl,
         slidesToShow: items,
         slidesToScroll: 1,
         asNavFor: asNavFor_for,
         centerMode: false,
         loop: false,
         focusOnSelect: true,
         dots: false,
         arrows: false,
         responsive: [
            {
               breakpoint: 1920,
               settings: {
                  slidesToShow: items,
               },
            },
            {
               breakpoint: 1200,
               settings: {
                  slidesToShow: items_lg_tablet,
               },
            },
            {
               breakpoint: 992,
               settings: {
                  slidesToShow: items_tablet,
               },
            },
            {
               breakpoint: 768,
               settings: {
                  slidesToShow: items_mobile,
               },
            },
            {
               breakpoint: 576,
               settings: {
                  slidesToShow: items_mobiles,
               },
            },
         ],
      });
   });
};
novtheme.Product_Megamenu = function () {
   var $this = $(".novmenu_product");
   var autoplay = $($this).data("autoplay");
   var autoplaytimeout = $($this).data("autoplaytimeout");
   var dots = $($this).data("dots");
   var nav = $($this).data("nav");
   $($this).slick({
      nextArrow:
         '<div class="arrow-next"><i class="fa fa-long-arrow-left"></i></div>',
      prevArrow:
         '<div class="arrow-prev"><i class="fa fa-long-arrow-right"></i></div>',
      lazyLoad: true,
      autoplay: autoplay,
      autoplaytimeout: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: nav,
      dots: dots,
      infinite: true,
      fade: false,
      responsive: {
         0: {
            items: 1,
         },
         768: {
            items: 1,
         },
         992: {
            items: 1,
         },
         1200: {
            items: 1,
         },
      },
   });
};
novtheme.RunInstagram = function () {
   if ($(".nov-image-centered").length > 0) {
      var winHeight = $(window).height();
      var Event = false,
         offset_top = $(".nov-image-centered").offset().top,
         distance = offset_top - winHeight;
      $(window).on("scroll", function () {
         var currentPosition = $(document).scrollTop();
         if (currentPosition > distance && Event === false) {
            Event = true;
            setTimeout(function () {
               $(".nov-image-centered").addClass("ins-animate");
            }, 1000);
         }
      });
   }
};
novtheme.NovAccordion = function () {
   $(".nov-accordion__title").click(function () {
      if ($(this).hasClass("act")) {
         $(this).removeClass("act"),
            $(this).parent().find(".nov-accordion__content").slideUp();
      } else {
         $(this)
            .parents(".nov-accordion")
            .find(".nov-accordion__title")
            .removeClass("act"),
            $(this)
               .parents(".nov-accordion")
               .find(".nov-accordion__content")
               .slideUp(),
            $(this).addClass("act"),
            $(this).parent().find(".nov-accordion__content").slideDown();
      }
   });
};
novtheme.CollectionPage = function () {
   if (localStorage.getItem("view_collection")) {
      $(".collection__product-content").attr(
         "data-grid",
         localStorage.getItem("view_collection")
      );
      $(".gridlist-toggle a").removeClass("active");
      $(
         '.gridlist-toggle [data-type="' +
            localStorage.getItem("view_collection") +
            '"]'
      ).addClass("active");
   }
   $(".gridlist-toggle a").click(function (e) {
      e.preventDefault();
      var typeview = $(this).data("type");
      if (!$(this).hasClass("active")) {
         $(".collection__product-content").attr("data-grid", typeview);
         $(".gridlist-toggle a").removeClass("active");
         $(this).addClass("active");
      }
      localStorage.setItem(
         "view_collection",
         $(".collection__product-content").attr("data-grid")
      );
   });

   $(".filter_button").click(function () {
      $(".sidebar-filter").addClass("active");
      $(".sidebar-overlay").addClass("act");
   });
   $(document).on("click", ".close-filter", function () {
      $(".sidebar-filter").removeClass("active");
      $(".sidebar-overlay").removeClass("act");
   });
   if ($(document).width() < 992) {
      $(".collection__product-content").attr("data-grid", "grid-3");
      $(".gridlist-toggle a").removeClass("active");
      $(".gridlist-toggle #grid-3").addClass("active");
   }
   if ($(document).width() < 768) {
      $(".collection__product-content").attr("data-grid", "grid-2");
      $(".gridlist-toggle a").removeClass("active");
      $(".gridlist-toggle #grid-2").addClass("active");
   }
   // Click filter sort by — fsSyncSortByLabel (Notre sélection / manual)
   function fsSyncSortByLabel() {
     var $sel = $('select[name="sort_by"]').first();
     var text = ($sel.find('option:selected').text() || $sel.find('[selected="selected"]').text() || '').trim();
     if (!text) {
       var sortParam = new URLSearchParams(window.location.search).get('sort_by');
       if (!sortParam && window.location.pathname.indexOf('/collections/parfums') !== -1) {
         sortParam = 'manual';
       }
       if (sortParam) {
         var $item = $('[data-sortby-item]').filter(function () {
           return $(this).attr('value') === sortParam;
         }).first();
         if ($item.length) text = $item.text().trim();
       }
     }
     $('[data-sortby-filter] .sort-by__label').text(text);
   }
   fsSyncSortByLabel();
   document.addEventListener('facets:updated', fsSyncSortByLabel);
   $("[data-sortby-item]").click(function () {
      var valuesort = $(this).attr("value");
      var newtext = $(this).text();
      $("[data-sortby-filter] .sort-by__label").text(newtext);
      
      // Check if this is a custom sort (vendor sort)
      if ($(this).attr("data-custom-sort") !== undefined) {
         // Custom client-side sorting by vendor
         novtheme.sortProductsByVendor(valuesort);
      } else {
         // Standard Shopify sorting
         $('[name="sort_by"]').val(valuesort);
         const form = document.querySelector("facet-filters-form");
         form.onSubmitHandlerSortBy(event, form.querySelector("form"));
      }
   });
   if ($(".reset_price").length) {
      window.onload = function () {
         var min = $(".min_price .money").text().slice(1),
            max = $(".max_price .money").text().slice(1),
            m = $(".filter-max__price").data("max"),
            n = $(".filter-max__price .money").text().slice(1),
            x = m / n;
         $(".facets__price")
            .find("input")
            .first()
            .val(Math.round(min))
            .attr({ max: Math.round(max), "data-value": Math.round(max * x) });
         $(".facets__price")
            .find("input")
            .last()
            .val(Math.round(max))
            .attr({
               max: Math.round(n),
               min: Math.round(min),
               "data-value": Math.round(max * x),
            });
      };
   }
};
$(document).ready(function () {
   var d = $(this),
      mobile = false;
   responsive_mobile = window.isMobileViewport();
   novtheme.toggleMobileStyles();
   $(novtheme.init);

   $(window).on("load", function () {
      if (!window.isMobileViewport()) return;
      novtheme.applyMobileLayout();
      jQuery.getJSON("/cart.js", function (cart) {
         if (typeof window.updateCartBadges === "function") {
            window.updateCartBadges(cart.item_count);
         }
      });
   });
   if ($("#popup-subscribe").length) {
      $(window).on("load", function () {
         var timer = window.setTimeout(novtheme.PopupNewletter(), 2000);
      });
   }
   if ($("#popupAlert").length) {
      $(window).on("load", function () {
         $("#popupAlert").modal();
      });
   }
   $(window).on("resize", function () {
      if (d.width() <= 980 && mobile == false) {
         mobile = true;
      } else if (d.width() > 980) {
         mobile = false;
      }
   });

   // Menu tablette / accordion : toute la ligne parent ouvre le sous-menu (doigt)
   function fsToggleNavParent($toggle) {
      var $icon = $toggle.find(".show_mor, .show_sub").first();
      if (!$icon.length) {
         $icon = $toggle.siblings(".show_sub, .show_mor").first();
      }
      var $li = $toggle.closest(
         ".site-nav--has-dropdown, .site-nav__childlist-item, .hasMegaMenu, .icon_menu"
      );
      var $panel = $li.children(
         ".dropdown_menu, .site-nav__dropdown, .site-nav__dropdown-children"
      );
      if (!$panel.length) return;

      var isOpen =
         $icon.hasClass("active") || $li.hasClass("site-nav--active-dropdown");

      if (isOpen) {
         $icon.removeClass("active");
         $li.removeClass("site-nav--active-dropdown");
         $toggle.attr("aria-expanded", "false");
         $panel.stop(true, true).slideUp(300);
         $icon
            .find("i")
            .add($icon.filter("i"))
            .addClass("zmdi-caret-right")
            .removeClass("zmdi-caret-down");
      } else {
         $li
            .siblings(
               ".site-nav--has-dropdown, .site-nav__childlist-item, .hasMegaMenu, .icon_menu"
            )
            .each(function () {
               var $sib = $(this);
               $sib.removeClass("site-nav--active-dropdown");
               $sib
                  .children("a.site-nav__parent-toggle")
                  .attr("aria-expanded", "false");
               $sib
                  .find("> .show_sub, > a .show_mor, > a .show_sub")
                  .removeClass("active")
                  .find("i")
                  .removeClass("zmdi-caret-down")
                  .addClass("zmdi-caret-right");
               $sib
                  .children(".dropdown_menu, .site-nav__dropdown-children")
                  .stop(true, true)
                  .slideUp(300);
            });

         $icon.addClass("active");
         $li.addClass("site-nav--active-dropdown");
         $toggle.attr("aria-expanded", "true");
         $panel.stop(true, true).slideDown(300);
         $icon
            .find("i")
            .add($icon.filter("i"))
            .addClass("zmdi-caret-down")
            .removeClass("zmdi-caret-right");
      }
   }

   $(document).on(
      "click",
      "#AccessibleNavTablet a.site-nav__parent-toggle, #AccessibleNav a.site-nav__parent-toggle, .vertical_menu a.site-nav__parent-toggle",
      function (e) {
         e.preventDefault();
         if ($(window).width() >= 1200) return;
         fsToggleNavParent($(this));
      }
   );

   // Flèche hors du lien (icon_menu) : même comportement
   $(document).on(
      "click",
      "#AccessibleNavTablet > .site-nav .show_sub, #AccessibleNav .icon_menu > .show_sub, .ver_menu .icon_menu > .show_sub",
      function (e) {
         e.preventDefault();
         e.stopPropagation();
         if ($(window).width() >= 1200) return;
         var $toggle = $(this).siblings("a.site-nav__parent-toggle").first();
         if ($toggle.length) fsToggleNavParent($toggle);
      }
   );

   // mobile vertical sidebar
   $(".btn-mobile_vertical_menu").click(function () {
      $("#_mobile_vertical_menu").addClass("active");
      $("#_mobile_sidebarmenu_content").addClass("active");
      $(".sidebar-overlay").addClass("act");
   });

   // vertical dropdown (tablette md–lg) — drawer #AccessibleNavTablet uniquement
   if ($(window).width() <= 1199 && $(window).width() >= 768) {
      $(".vertical_dropdown").click(function () {
         if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $("#AccessibleNavTablet").removeClass("active");
            $(".sidebar-overlay").removeClass("act");
         } else {
            $(this).addClass("active");
            $("#AccessibleNavTablet").addClass("active");
            $(".account-list").removeClass("active");
            $("#_desktop_cart").removeClass("active");
            $(".sidebar-overlay").addClass("act");
         }
      });
   }

   var show_more = $(".vertical_menu").data("count_showmore");

   if ($(".vertical_menu>ul>li").length > show_more) {
      $(".vertical_menu .show_more").removeClass("hidden");
   }
   $(".vertical_menu .show_more").click(function () {
      if ($(this).hasClass("active")) {
         $(this).removeClass("active");
      } else {
         $(this).addClass("active");
      }
      if ($(".vertical_menu>ul>li").hasClass("hide")) {
         $(".vertical_menu>ul>li.hide").slideToggle(300);
      }
   });

   if ($(document).width() > 767) {
      $(".site-header_myaccount").click(function () {
         $(this).addClass("active");
         $(".sidebar-overlay").addClass("act");
         $(".account-list").addClass("active");
         $("#_desktop_cart").removeClass("active");
      });
      $(".header-cart").click(function () {
         $(".sidebar-overlay").addClass("act");
         $("#_desktop_cart").addClass("active");
         $(".account-list").removeClass("active");
      });
      $(".close_account .zmdi-close").click(function () {
         $(this).removeClass("active");
         $(".sidebar-overlay").removeClass("act");
         $(".account-list").removeClass("active");
      });
      $(".close_cart .zmdi-close").click(function () {
         $(".sidebar-overlay").removeClass("act");
         $("#_desktop_cart").removeClass("active");
      });
   }

   $(".sidebar-overlay").click(function () {
      $(this).removeClass("act");
      $("#_mobile_vertical_menu").removeClass("active");
      $(".vertical_toggle").removeClass("active");
      $(".btn_active").css("opacity", "1");
      if ($(document).width() >= 992) {
         $("#_desktop_vertical_menu").slideUp(450);
      }
      $(".vertical_dropdown").removeClass("active");
      $(".sidebar_menu").removeClass("active");
      $(".sidebar-filter").removeClass("active");
      $("#AccessibleNavTablet").removeClass("active");
      $(".ver_menu").removeClass("active");
      $(".site-header_myaccount").removeClass("active");
      $(".account-list").removeClass("active");
      $("#_desktop_cart").removeClass("active");
   });

   // Related products: same Slick carousel as homepage (page-by-page + dots)
   var $relatedGrid = $(".ProductRelated .fs-related-carousel");
   if (
      $relatedGrid.length &&
      typeof $.fn.slick === "function" &&
      !$relatedGrid.hasClass("slick-initialized")
   ) {
      var relatedRtl = $("html").hasClass("lang-rtl");
      var relatedItems = $relatedGrid.data("items") || 6;
      var relatedTablet = $relatedGrid.data("items_tablet") || 4;
      var relatedMobile = $relatedGrid.data("items_mobile") || 3;
      $relatedGrid.slick({
         nextArrow:
            '<button type="button" class="arrow-next slick-arrow" aria-label="Suivant"><svg class="fs-related-chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><polyline points="9.5,6 15.5,12 9.5,18" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
         prevArrow:
            '<button type="button" class="arrow-prev slick-arrow" aria-label="Précédent"><svg class="fs-related-chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><polyline points="14.5,6 8.5,12 14.5,18" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
         rtl: relatedRtl,
         slidesToShow: relatedItems,
         slidesToScroll: relatedItems,
         arrows: true,
         dots: true,
         infinite: false,
         adaptiveHeight: false,
         responsive: [
            {
               breakpoint: 1200,
               settings: {
                  slidesToShow: relatedTablet,
                  slidesToScroll: relatedTablet,
                  arrows: true,
                  dots: true,
               },
            },
            {
               breakpoint: 768,
               settings: {
                  slidesToShow: relatedMobile,
                  slidesToScroll: relatedMobile,
                  arrows: false,
                  dots: true,
               },
            },
         ],
      });
      var $relatedControls = $(".ProductRelated .fs-related-controls");
      function syncRelatedCenter() {
         var slick = $relatedGrid.slick("getSlick");
         if (!slick) return;
         var shouldCenter = slick.slideCount < slick.options.slidesToShow;
         $relatedGrid.toggleClass("fs-related--center", shouldCenter);
         var $track = $relatedGrid.find(".slick-track");
         if (!shouldCenter || !$track.length) return;
         // Réécrit après le setPosition Slick (sinon il écrase margin/transform)
         $track.css({
            display: "flex",
            "justify-content": "center",
            width: "100%",
            transform: "translate3d(0, 0, 0)",
            left: 0,
            margin: "0 auto",
         });
      }
      function moveRelatedArrows() {
         if ($relatedControls.length) {
            $relatedGrid.find(".slick-arrow").appendTo($relatedControls);
         }
         window.requestAnimationFrame(syncRelatedCenter);
      }
      moveRelatedArrows();
      $relatedGrid.on("init breakpoint setPosition reInit", moveRelatedArrows);
   }
   $(".menu_button").click(function () {
      $(".sidebar_menu").addClass("active");
      $(".sidebar-overlay").addClass("act");
   });
   $(".close-menu").click(function () {
      $(".sidebar_menu").removeClass("active");
      $(".sidebar-overlay").removeClass("act");
   });
   novtheme.NovMediumToggle = function () {
      $(".card-header").on("click", function (e) {
         $(this).hasClass("active")
            ? $(this).removeClass("active")
            : $(this).addClass("active");
      });
   };
   novtheme.HideShowPassword = function () {
      $(".hide_show_password").show();
      $(".hide_show_password span").addClass("show");

      $(".hide_show_password span").click(function () {
         if ($(this).hasClass("show")) {
            $(this).html('<i class="zmdi zmdi-eye"></i>');
            $('input[name="customer[password]"]').attr("type", "text");
            $(this).removeClass("show");
         } else {
            $(this).html('<i class="zmdi zmdi-eye-off"></i>');
            $('input[name="customer[password]"]').attr("type", "password");
            $(this).addClass("show");
         }
      });

      $('form button[type="submit"]').on("click", function () {
         $(".hide_show_password span").text("Show").addClass("show");
         $(".hide_show_password")
            .parent()
            .find('input[name="customer[password]"]')
            .attr("type", "password");
      });
   };
   $(".group-quantity .btnProductWishlist").click(function () {
      if ($(this).hasClass("whislist-added")) {
         $("#popup-Wishlist").removeClass("novload");
      } else {
         $("#popup-Wishlist").addClass("novload");
      }
   });
   novtheme.galery_image = function () {
      $('[data-fancybox="gallery"]').fancybox({
         buttons: [
            "slideShow",
            "thumbs",
            "zoom",
            "fullScreen",
            "share",
            "close",
         ],
         loop: false,
         protect: true,
      });
      $('[data-fancybox="product-gallery"]').fancybox({
         buttons: ["zoom", "thumbs", "close"],
         loop: true,
         infobar: true,
         animationEffect: "zoom-in-out",
         transitionEffect: "slide",
         backFocus: false,
         hash: false,
         thumbs: { autoStart: false },
      });
   };

   $(".product-swatch-color a").click(function (e) {
      e.preventDefault();
      var data_image_variant = $(this).data("image-variant");
      var src_img = $(this)
         .parents(".item-product")
         .find(".product__thumbnail");
      src_img.attr("srcset", data_image_variant);
      $(this)
         .parents(".item-product")
         .find(".product__thumbnail-second")
         .addClass("hidden");
      $(this)
         .parents(".item-product")
         .find(".product__thumbnail")
         .addClass("block");
      $(this)
         .parent(".swatch-element")
         .addClass("act")
         .siblings()
         .removeClass("act");
   });
   $(".product-swatch-color").each(function () {
      var n = $(this).children(".swatch-element").length - 3;
      if ($(this).children(".swatch-element").length > 3) {
         $(this).find(".number").text(n);
         $(this).find(".show_more").show();
      }
      $(this).find(".swatch-element:gt(2)").addClass("hide");
      $(this)
         .children(".show_more")
         .click(function () {
            if ($(this).hasClass("active")) {
               $(this).parent().find(".hide").hide();
               $(this).removeClass("active");
               $(this).parent().find(".number").show();
            } else {
               $(this).parent().find(".hide").show();
               $(this).addClass("active");
               $(this).parent().find(".number").hide();
            }
         });
   });

   $(".btnsold_out").click(function () {
      $(".note").addClass("d-none");
      $(".loading").addClass("d-block");
      $(".loading i").addClass("fa-spinner");
      setTimeout(RemoveClass, 500);
   });

   // Accordion footer mobile — toute la ligne titre cliquable (pas seulement le +)
   $(document).on("click", ".footer-block .title-block", function (e) {
      var $toggle = $(this).find(".show_footer");
      if (!$toggle.length || !$toggle.is(":visible")) return;
      e.preventDefault();
      var $block = $(this).closest(".footer-block");
      if ($toggle.hasClass("adds")) {
         $toggle.removeClass("adds");
         $block.find(".block-content.adc").slideUp(300);
      } else {
         $(".show_footer").removeClass("adds");
         $(".footer-block .block-content.adc").slideUp(300);
         $toggle.addClass("adds");
         $block.find(".block-content.adc").slideDown(300);
      }
   });

   $(".no-view").click(function () {
      if ($(".contact-form").hasClass("add")) {
         $(".contact-form").removeClass("add");
      } else {
         $(".contact-form").addClass("add");
      }
   });

   function RemoveClass() {
      $(".note").removeClass("d-none");
      $(".loading").removeClass("d-block");
      $(".loading i").removeClass("zmdi-hc-spin");
   }

   if ($(window).width() > 767 && typeof $.fn.zoom === "function") {
      var $productImageZoom = $(".image-zoom");
      $productImageZoom.trigger("zoom.destroy");
      $productImageZoom.each(function() {
         var $img = $(this);
         var zoomUrl = $img.attr("data-zoom") || $img.attr("src");
         $img
            .wrap('<span style="display:inline-block"></span>')
            .css("display", "block")
            .parent()
            .zoom({
               url: zoomUrl,
            });
      });
   }

   if (typeof WOW === "function") {
      new WOW().init();
   }
});

